//@ts-nocheck
import React, {useState, VFC, FocusEvent, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  UpdateConditionalFieldValue,
  UpdateShowSectionStatus,
} from "../../../ReduxImpl/actions/index";
import {ListFieldProps} from "@sitecore-jss/sitecore-jss-react-forms";
import {DropdownListViewModel} from "@sitecore-jss/sitecore-jss-forms";
import {IReduxState} from "../../../ReduxImpl/reducers/index";
import {useHistory} from "react-router-dom";

import ContactUsCallUs from "../../../../../components/ContactUsTemplate/ContactUsCallUs/ContactUsCallUs";

const Dropdownfield: VFC<ListFieldProps<DropdownListViewModel>> = (props) => {
  const {field, tracker} = props;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!props.errors?.length;
  const [value, setDdlValue] = useState(props.value);
  const hasValueOrFocus = hasFocus || value.length !== 0;
  const isCallUs = props.field.model.name === "callUsCountry";
  var options = props.field.model.items.map((x, idx) => (
    <option
      key={idx}
      value={x.value}
      className="sitecore-jss-form__field--option"
    >
      {x.text}
    </option>
  ));
  if (field.model.showEmptyItem) {
    options.unshift(<option key={-1} value=""></option>);
  }
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;

  const dispatch = useDispatch();
  const history = useHistory();

  let fieldValues = useSelector((state: IReduxState) => state.fieldValues);

  /**
   * THIS IS FALLBACK LANG
   */
  // const  supportedLang = ['en', 'it-IT'];
  // const  defaultLang = 'en';
  // const getFallbackLang =  (lang)=>{
  //   if(lang){
  //    const isSupported = supportedLang.some((l)=> l === lang )
  //    return isSupported?lang:defaultLang;
  //   }

  //   return defaultLang;

  // }
  const getCookieValue = (name) => {
    let result =
      typeof document != "undefined"
        ? document.cookie.match("(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)")
        : null;
    return result ? result.pop() : "";
  };

  const onChange = (e: any): void => {
    const currentLang: string = e.target.value;

    fieldValues[field.model["conditionSettings"].fieldKey] = e.target.value;

    if (field.model.name === "LanguageDropdownList") {
      var d = new Date();
      d.setTime(d.getTime() + 5 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      //getLayoutServiceData(dispatch, e.target.value)
      const currentPath = history?.location?.pathname;
      //const prevLang = localStorage.getItem("lang");
      const prevLang = getCookieValue("corporate#lang");
      //localStorage.setItem("lang",currentLang);
      if (typeof document != "undefined")
        document.cookie =
          "corporate#lang=" + currentLang + ";path=/;" + expires;
      //history.push(currentPath,{params:{forceReload : prevLang!=currentLang ? true : false}});
      window.location.reload();

      dispatch(UpdateShowSectionStatus(false));
    } else if (field.model["conditionSettings"].fieldKey in fieldValues) {
      if (field.model.name === "LawUnderDropdownList" && e.target.value == "") {
        dispatch(UpdateShowSectionStatus(false));
      } else if (field.model.name !== "CountryDropdownList") {
        dispatch(UpdateShowSectionStatus(true));
      }

      dispatch(UpdateConditionalFieldValue(fieldValues));
    }
    setDdlValue(e.target.value);

    props.onChange(field.valueField.name, e.target.value, props.isValid, []);
  };

  //TODO:
  const onFocus = (e: FocusEvent<HTMLSelectElement>) => {
    tracker.onFocusField(field, e.target.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLSelectElement>) => {
    tracker.onBlurField(field, e.target.value);
    setHasFocus(false);
  };

  const getDdlValue = (propsvalue: any): any => {
    if (Array.isArray(propsvalue)) {
      return props.value.length > 0 ? props.value[0] : "";
    } else {
      return props.value;
    }
  };

  const getDropdownVal = () => {
    if (field.model.name === "LanguageDropdownList") {
      return getCookieValue("corporate#lang") || typeof value === "string"
        ? value
        : "";
    }

    return typeof value === "string" ? value : "";
  };
  useEffect(() => {
    if (getDdlValue(props?.value)) {
      onChange({target: {value: getDdlValue(props?.value)}});
      SetHasStartingValue(true);
    }
  }, []);

  const [hasStartingValue, SetHasStartingValue] = useState(false);

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box sitecore-jss-form__dropdown ${
        hasAnyError ? "sitecore-jss-form__control--has-error" : ""
      } ${
        field.model.name === "LanguageDropdownList"
          ? "sitecore-jss-form__control--LanguageAlign"
          : ""
      }`}
    >
      {/* ${hasStartingValue ? 'disabled' : ''} */}
      {field.model.name === "LanguageDropdownList" ? (
        <div> {label} </div>
      ) : (
        <label
          htmlFor={id}
          className={`sitecore-jss-form__label dropdownLabel ${
            hasValueOrFocus ? "sitecore-jss-form__label--has-focus" : ""
          } `}
        >
          {label}
        </label>
      )}

      {isCallUs ? (
        <ContactUsCallUs
          callLabel="call us"
          callSubtitle="select country"
          callNumbersList={props.field.model.items.map(({value, text}) => ({
            label: text,
            number: value,
          }))}
        />
      ) : (
        <select
          id={id}
          name={name}
          className={`sitecore-jss-form__field ${
            field.model.name === "LawUnderDropdownList"
              ? "lawdropdownWidth"
              : ""
          } ${
            field.model.name === "LanguageDropdownList"
              ? "languagedropdownStyle"
              : ""
          } `}
          onChange={onChange}
          //value={getDdlValue(props.value)}
          value={getDropdownVal()}
          //value={value}
          // TODO:
          onFocus={onFocus}
          onBlur={onBlur}
        >
          {options}
        </select>
      )}

      <FieldValidationErrors {...props} />
    </div>
  );
};

export default Dropdownfield;
